import { ApiTemplate,UserToken } from '../../../helper/HelperAuth'
import { GlobalLoading } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'
import { fromJS } from 'immutable';

export default (file) => async (dispatch, getState) => {
    dispatch({ type: GlobalLoading, showLoading: true, latestProcessStatus: false });

    const Authorization = UserToken;
    const url = ApiTemplate + 'upload';
    // const url = 'http://10.0.7.96/testingRest/uploadFileExample.php';

    const data = new FormData();
    data.append('file', file );


    const argument = {
        method: 'POST',
        headers : {
            'Authorization': Authorization,
        },
        body : data
    };
    const response = await doFetch(url,argument);
    
    dispatch({ type: GlobalLoading, showLoading: false, latestProcessStatus : response.ok });

    try{
        if(response.ok){
            var res = fromJS(await response.json());
            //debugger;
            res = res.get('query-result').get('data');
            // res = res.get(0)
            return fromJS({
                'success': true,
                "idSession": res.get('idSession'),
                "idUpload": res.get('idUpload'),
                "statusCode": res.get('statusCode'),
                "isSuccess":res.get('isSuccess')
            });
        }
    }catch(ex){

    }
    
    return fromJS({
        'success': false
    })
};